import { Competitor } from '@retail/retailer/types';
import { usePagination } from '@shared/hooks';
import { useFetchMonitoringAssortmentItems } from '@retail/monitoring-assortment/data-access';
import { MonitoringAssortmentItem } from '@retail/monitoring-assortment/types';

interface Props {
  assortmentId: number;
  competitors: Competitor[];
  groupNumbers?: string[];
  discountGroupIds?: number[];
  supplierIds?: number[];
  query?: string;
  initPageSize?: number;
}

export const useMonitoringAssortmentItems = ({
  assortmentId,
  competitors,
  groupNumbers,
  discountGroupIds,
  supplierIds,
  query,
  initPageSize = 500,
}: Props) => {
  const pagination = usePagination({
    initPageSize,
    initPage: 0,
  });

  const { data: assortmentPagePaginationDto, isFetching } = useFetchMonitoringAssortmentItems(
    {
      assortmentId,
      competitorStoreIds: competitors.map((competitor) => competitor.id),
      page: pagination.page,
      supplierIds,
      size: pagination.pageSize,
      nCmpPrices: 2,
      groupNumbers,
      discountGroupIds,
      query,
    },
    { suspense: false }
  );

  const assortmentItems = assortmentPagePaginationDto?.result
    ? assortmentPagePaginationDto.result.map((itemDto) => new MonitoringAssortmentItem(itemDto))
    : [];

  if (
    !!assortmentPagePaginationDto?.totalCount &&
    assortmentPagePaginationDto?.totalCount !== pagination.totalCount
  ) {
    pagination.setTotalCount(assortmentPagePaginationDto.totalCount);
  }

  return {
    result: {
      totalItems: pagination.totalCount,
      assortmentItems,
    },
    pagination,
    isFetching,
  };
};
